import { render } from "./furtherEmail.vue?vue&type=template&id=20895a25&lang=pug"
import script from "./furtherEmail.vue?vue&type=script&lang=js"
export * from "./furtherEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/furtherEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20895a25"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20895a25', __exports__)) {
    api.reload('20895a25', __exports__)
  }
  
  module.hot.accept("./furtherEmail.vue?vue&type=template&id=20895a25&lang=pug", () => {
    api.rerender('20895a25', render)
  })

}


export default __exports__